<check-box [view]="viewModel" (onValueChange)="onValueChange.emit($event)" >           
</check-box>